import { Box, Button, type ButtonProps } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router';
import type { ReactNode } from 'react';
import Tooltip from '@/components/Tooltip';

interface Props extends ButtonProps {
  path: string;
  icon: ReactNode;
  label: string;
  isCollapsed?: boolean;
  onClose?: () => void;
}

const SidebarLink = (props: Props) => {
  const { icon, label, path, isCollapsed, onClose, ...buttonProps } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const subPath = location.pathname.split('/painel')[1];
  const isCurrentPage = subPath.includes(path);

  const handleClick = () => {
    navigate(`/painel/${path}`);
    if (onClose) {
      onClose();
    }
  };

  const button = (
    <Button
      size="sm"
      variant="ghost"
      width="full"
      justifyContent={isCollapsed ? 'center' : 'start'}
      gap="3"
      px={isCollapsed ? '0' : undefined}
      fontWeight={isCurrentPage ? 600 : 400}
      color={isCurrentPage ? 'primary.500' : 'fg.muted'}
      _hover={{
        color: isCurrentPage ? 'primary.500' : 'fg.muted',
        bg: 'primary.50',
        fontWeight: 600,
      }}
      asChild
      onClick={handleClick}
      {...buttonProps}
    >
      <Box>
        {icon}
        {!isCollapsed && label}
      </Box>
    </Button>
  );

  if (isCollapsed) {
    return (
      <Tooltip content={label} positioning={{ placement: 'right' }} showArrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default SidebarLink;
